import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button, Container, Table, Form } from "react-bootstrap";
import "./productsList.css";
import { useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import axios from "axios";
import QRCodeStyling from "qr-code-styling";

const ProductList = () => {
  const user = useSelector((state) => state.authentication.user);
  const [products, setproducts] = useState([]);
  const navigate = useNavigate();
  const [ornaments, setOrnaments] = useState(["All"]);

  const getResponse = async () => {
    try {
      const res = await axios.get(`/api/products/`);
      setproducts(res.data);

      const ornamentSet = new Set(
        res.data.map((p) => p.Ornament).filter(Boolean),
      );
      setOrnaments(["All", ...Array.from(ornamentSet).sort()]);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    getResponse();
  }, []);

  const newForm = () => {
    navigate("/create-product");
  };

  const handleDelete = async (tagNo) => {
    if (!window.confirm("Are you sure you want to delete this product?"))
      return;

    try {
      const response = await axios.delete(`/api/product/${tagNo}`);

      if (response.status === 204) {
        alert("Product deleted successfully.");
        window.location.reload();
      } else {
        console.log(response.data);
        alert("Failed to delete product.");
      }
    } catch (error) {
      console.error("Error deleting product:", error);
      alert("An error occurred.");
    }
  };

  const [selectedOrnament, setSelectedOrnament] = useState(
    () => localStorage.getItem("selectedOrnament") || "All",
  );
  const [searchQuery, setSearchQuery] = useState("");

  const handleOrnamentChange = (e) => {
    const value = e.target.value;
    setSelectedOrnament(value);
    localStorage.setItem("selectedOrnament", value);
  };

  const filteredProducts = products
    .filter((product) =>
      selectedOrnament === "All" ? true : product.Ornament === selectedOrnament,
    )
    .filter((product) =>
      (product.Tag_No || "").toLowerCase().includes(searchQuery.toLowerCase()),
    )
    .sort((a, b) => {
      if (selectedOrnament !== "All") {
        return (a.Tag_No || "").localeCompare(b.Tag_No || "");
      }

      // First, sort by Ornament
      const ornamentA = a.Ornament || "";
      const ornamentB = b.Ornament || "";
      const ornamentCompare = ornamentA.localeCompare(ornamentB);

      if (ornamentCompare !== 0) return ornamentCompare;

      // If ornaments are equal, sort by Tag_No
      return (a.Tag_No || "").localeCompare(b.Tag_No || "");
    });

  console.log(filteredProducts);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleDownloadQR = (tagNo) => {
    const qrCode = new QRCodeStyling({
      width: 300,
      height: 300,
      data: `https://zeyvvar-qr.in/#/p/${tagNo}`,
      imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.4,
        margin: 5,
        crossOrigin: "anonymous",
      },
      dotsOptions: {
        type: "extra-rounded",
        color: "rgb(2, 51, 49)",
      },
      backgroundOptions: {
        color: "#ffffff",
      },
      cornersSquareOptions: {
        type: "extra-rounded",
        color: "rgb(2, 73, 71)",
      },
      cornersDotOptions: {
        type: "",
        color: "rgb(2, 73, 71)",
      },
    });

    // Create a temporary canvas to draw QR code and convert to image
    const tempDiv = document.createElement("div");
    qrCode.append(tempDiv);

    setTimeout(() => {
      qrCode.getRawData("jpeg").then((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${tagNo}.jpeg`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      });
    }, 500); // small delay to ensure QR is rendered
  };

  return (
    <div>
      <Container style={{ maxWidth: "80%", paddingTop: "10vh" }}>
        <Row style={{ marginBottom: "1em" }}></Row>

        <Row style={{ marginBottom: "1em" }}>
          <Col
            md={12}
            className="d-flex align-items-center justify-content-center"
          >
            <h3 style={{ margin: 0 }}>Products</h3>
          </Col>
        </Row>
        <Row style={{ marginBottom: "1em" }}>
          <Col md={3}>
            <Form.Select
              value={selectedOrnament}
              onChange={handleOrnamentChange}
            >
              {ornaments.map((ornament, idx) => (
                <option key={idx} value={ornament}>
                  {ornament}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={7}>
            <Form.Control
              type="text"
              placeholder="Search by Tag No..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </Col>

          <Col md={2} className="d-flex justify-content-end">
            <Button className="btn--primary" onClick={newForm}>
              New Product
            </Button>
          </Col>
        </Row>

        <Table responsive="md" striped bordered>
          <thead className="tableHead">
            <tr>
              <th>S. No.</th>
              <th>Ornament</th>
              <th>Tag</th>
              <th>QR</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="tableBody">
            {filteredProducts.slice(0).map((product, index) => (
              <tr key={product.id}>
                <td>{index + 1}</td>
                <td>{product.Ornament}</td>
                <td>{product.Tag_No}</td>
                <td style={{ width: "10rem" }}>
                  <Button
                    variant="secondary"
                    className="btn--four"
                    style={{ marginLeft: "5px" }}
                    onClick={() => handleDownloadQR(product.Tag_No)}
                  >
                    Download QR
                  </Button>
                </td>
                <td style={{ width: "20rem" }}>
                  <Row>
                    <Col style={{ textAlign: "center" }}>
                      <LinkContainer
                        style={{ marginRight: "5px" }}
                        to={`/p/${product.Tag_No}`}
                      >
                        <Button variant="light" className="btn--four">
                          View Product
                        </Button>
                      </LinkContainer>
                      <Button
                        variant="danger"
                        className="btn--four"
                        style={{ marginLeft: "5px" }}
                        onClick={() => handleDelete(product.Tag_No)}
                      >
                        Delete Product
                      </Button>
                    </Col>
                  </Row>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
    </div>
  );
};

export default ProductList;
